import { useQuery } from "@tanstack/react-query";
import { getGrade } from "src/api";
import { useState } from "react";

const FilterShop = ({ setIsOpen, selectedGrade, setSelectedGrade }) => {
    const { data: grade, isLoading } = useQuery({
        queryKey: ["getGrade"],
        queryFn: getGrade,
    });

    const [tempGrade, setTempGrade] = useState(selectedGrade); // Temporary grade selection

    const handleApply = () => {
        setSelectedGrade(tempGrade);  // Apply grade filter
        setIsOpen(false);  // Close modal
    };

    return (
        <div className="p-4 rounded-md">
            {/* Grade Dropdown */}
            <div className="mb-4">
                <label className="block mb-2 font-semibold">Grade</label>
                <select
                    className="w-full p-2 border rounded-md fatix-input-patterns"
                    value={tempGrade}
                    onChange={(e) => setTempGrade(e.target.value)}
                >
                    <option value="">Select a Grade</option>
                    {isLoading ? (
                        <option>Loading...</option>
                    ) : (
                        grade?.data?.map((g) => (
                            <option key={g.id} value={g.id}>
                                {g.name}
                            </option>
                        ))
                    )}
                </select>
            </div>

            {/* Apply Button */}
            <div className="color-apply-button-container">
                {/* <button className="reset1" onClick={() => setTempGrade("")}>Reset</button> */}
                <button onClick={handleApply} className="color-apply-button">Apply</button>
            </div>
        </div>
    );
};

export default FilterShop;

